import { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box,
    IconButton,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useLanguage } from '../../../../context/LanguageContext';

interface CreateGroupDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: (groupName: string) => void;
}

function CreateGroupDialog({
    open,
    onClose,
    onConfirm,
}: CreateGroupDialogProps) {
    const { t } = useLanguage();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [groupName, setGroupName] = useState('');

    const handleConfirm = () => {
        if (groupName.trim()) {
            onConfirm(groupName.trim());
            setGroupName('');
        }
    };

    const handleClose = () => {
        setGroupName('');
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            fullScreen={fullScreen}
        >
            <DialogTitle>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {t('pages.clients.queryBuilder.createGroupDialog.title')}
                    <IconButton onClick={handleClose} size="small">
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>

            <DialogContent>
                <TextField
                    autoFocus
                    fullWidth
                    label={t('pages.clients.queryBuilder.createGroupDialog.nameLabel')}
                    value={groupName}
                    onChange={(e) => setGroupName(e.target.value)}
                    placeholder={t('pages.clients.queryBuilder.createGroupDialog.namePlaceholder')}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter' && groupName.trim()) {
                            handleConfirm();
                        }
                    }}
                    sx={{ mt: 2 }}
                />
            </DialogContent>

            <DialogActions sx={{ p: 2 }}>
                <Button onClick={handleClose}>
                    {t('common.cancel')}
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    disabled={!groupName.trim()}
                    sx={{ bgcolor: '#556ee6' }}
                >
                    {t('pages.clients.queryBuilder.createGroupDialog.create')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default CreateGroupDialog;
